import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { IVideo } from 'rev-shared/media/IVideo';

import { VideogularComponent } from 'vbrick-player-src/videogular/Videogular.Component';

import { VideoPulseService } from './VideoPulse.Service';

import styles from './VideoPulseContainer.module.less';

@Component({
	selector: 'video-pulse-container',
	templateUrl: './VideoPulseContainer.Component.html'
})
export class VideoPulseContainerComponent implements OnChanges {
	@Input() public currentTimeSec: number;
	@Input() public filter: string;
	@Input() public vgApi: VideogularComponent;
	@Input() public video: IVideo;
	@Input() public activeSubtitleLang: string;

	public readonly styles = styles;

	constructor(
		public VideoPulse: VideoPulseService
	) { }

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.filter) {
			this.VideoPulse.setFilter(this.filter);
		}

		if (changes.activeSubtitleLang && this.activeSubtitleLang) {
			this.VideoPulse.setActiveSubtitleLanguage(this.activeSubtitleLang);
		}
	}
}
